import { RewardState } from "Infrastructure/Api/Api";
import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";
import { z } from "zod";

export const rewardSchema = z
  .object({
    name: z
      .string()
      .min(1, getTranslation(Resources.Validation.Required))
      .max(50, getTranslation(Resources.Validation.MaxLength))
      .refine((val) => val.trim().length > 0, {
        message: getTranslation(Resources.Validation.Required),
      })
      .transform((val) => val.trim()),
    cost: z.coerce
      .number({
        required_error: getTranslation(Resources.Validation.Required),
        invalid_type_error: getTranslation(Resources.Validation.Required),
      })
      .positive(getTranslation(Resources.Validation.Positive)),
    quantity: z
      .union([z.string(), z.number()])
      .transform((val) => (val === "" ? undefined : Number(val)))
      .optional()
      .refine((val) => val === undefined || val > 0, {
        message: getTranslation(Resources.Validation.Positive),
      })
      .nullable(),
    startDate: z.date().optional().nullable(),
    endDate: z.date().optional().nullable(),
    description: z
      .string()
      .max(300, getTranslation(Resources.Validation.MaxLength))
      .optional(),
    state: z.nativeEnum(RewardState).default(RewardState.Active),
  })
  .refine(
    (data) =>
      !data.startDate || !data.endDate || data.endDate >= data.startDate,
    {
      message: getTranslation(Resources.Validation.DateRange),
      path: ["expiration"],
    },
  );

export type RewardFormData = z.infer<typeof rewardSchema>;
export type RewardFormInput = z.input<typeof rewardSchema>;
